import styled from 'styled-components';
import { Container, Paragraph, SectionHeader, TextLink } from '@swordhealth/ui-corporate';

export const StyledContainer = styled(Container)`
  gap: 64px;
`;

export const StyledSectionHeader = styled(SectionHeader)`
  max-width: 720px;

  p:first-child {
    background-color: ${(props) => props.theme.colors.primary[50]};
  }
`;

export const BannerCard = styled.div`
  display: flex;
  max-width: 756px;
  background-color: white;
  background: ${({ $notColored, theme }) =>
    $notColored === false ? theme.colors.neutral[200] : theme.colors.white};
  border-radius: ${(props) => props.theme.borderRadius.default.lg};

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  flex: 1;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    align-items: center;
    padding: 24px;
  }
`;

export const TitlesWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;

  h2 {
    text-wrap: unset;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    text-align: center;
  }
`;

export const StyledTextLink = styled(TextLink)`
  font-size: 1rem;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    line-height: 32px;
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  width: 165px;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px;
  text-align: center;
  flex-shrink: 0;

  img {
    border-radius: 80px;
    margin-bottom: 16px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 100%;
    padding: 24px 0 0;
  }
`;

export const AvatarSubtitle = styled(Paragraph)`
  color: ${(props) => props.theme.colors.grey[600]};
`;
